import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AlcmeonCardFooter } from 'src/app/shared/components/card-footer/models/alcmeon-card-footer.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import { TrackLinkLabel } from '../shared';
import { TrackLinkLabelsService } from '../track-link-labels.service';

@Component({
  selector: 'app-track-link-label',
  templateUrl: './track-link-label.component.html',
  styleUrls: ['./track-link-label.component.scss'],
})
export class TrackLinkLabelComponent implements OnDestroy {
  create: boolean = this.customRouter.current.data?.create;

  trackLinkLabel: TrackLinkLabel;
  subscriptions: Subscription = new Subscription();

  form: FormGroup = this.formBuilder.group({
    id: [null],
    label: ['', Validators.required],
    description: [''],
  });
  backToLabel = this.basicService.translate('parameters/track-link-labels/details/back');
  templates = [];
  footerContent: AlcmeonCardFooter;

  constructor(
    private formBuilder: FormBuilder,
    private customRouter: CustomRouter,
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    private trackLinkLabelsService: TrackLinkLabelsService
  ) {
    if (!this.create) {
      const { trackLinkLabelId } = customRouter.params;
      this.basicService.showSpinner();
      this.trackLinkLabelsService
        .getTrackLinkLabel(trackLinkLabelId)
        .pipe(finalize(() => this.basicService.hideSpinner()))
        .subscribe({
          next: (trackLinkLabel: TrackLinkLabel) => {
            if (!trackLinkLabel) {
              return;
            }
            this.trackLinkLabel = trackLinkLabel;
            const { id, label, description } = trackLinkLabel;
            this.form.patchValue({ id, label, description });
            const { created_by, updated_by, created_at, updated_at } = trackLinkLabel;
            const defaultLabel = this.basicService.translate('admin/users/is_admin');
            const getColleagueName = (id: number) =>
              this.alcmeonContextService.getColleague(id)?.realname ?? defaultLabel;
            this.footerContent = {
              createdBy: getColleagueName(created_by),
              createdAt: created_at,
              modifiedBy: getColleagueName(updated_by),
              modifiedAt: updated_at,
            };
            this.basicService.showSpinner();
            this.trackLinkLabelsService
              .getTemplatesDependencies(trackLinkLabelId)
              .pipe(finalize(() => this.basicService.hideSpinner()))
              .subscribe(templates => (this.templates = templates));
          },
        });
    }
  }

  goBack() {
    this.customRouter.go('auth.alcmeon.fuse.parameters.track-link-labels');
  }

  save() {
    this.trackLinkLabelsService.saveTrackLinkLabel(this.form.value).subscribe({
      next: () => {
        this.basicService.translate('parameters/track-link-labels/details/saved');
        this.goBack();
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
